var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleReturn = function SvgDoubleReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#double-return_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.8,
    d: "M3.333 2.734a.6.6 0 0 0-.6.6v4a2.6 2.6 0 0 0 2.6 2.6H8.55L6.91 11.575a.6.6 0 0 0 .847.848l2.667-2.667a.6.6 0 0 0 0-.848L7.757 6.243a.6.6 0 1 0-.847.847l1.643 1.644h-3.22a1.4 1.4 0 0 1-1.4-1.4v-4a.6.6 0 0 0-.6-.6m7.758 3.509a.6.6 0 0 0-.848.847l2.243 2.243-2.243 2.243-.077.094a.6.6 0 0 0 .83.832l.095-.078 2.666-2.667a.6.6 0 0 0 0-.848z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "double-return_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  })))));
};
export default SvgDoubleReturn;